export default __webpack_public_path__ + "5a9fdc9a1dd696513266d5b5c73a9742.glb";